import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const PlayCircleIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M8 0.5C3.59869 0.5 0.5 3.5498 0.5 7.75391V8.2461C0.5 12.4512 3.59869 15.5 8 15.5C12.4013 15.5 15.5 12.4502 15.5 8.2461V7.75391C15.5 3.54858 12.4014 0.5 8 0.5ZM11.8322 8.29932L6.70196 11.4414C6.40191 11.6252 5.99999 11.4275 5.99999 11.0962V4.90381C5.99999 4.57227 6.40191 4.37476 6.70196 4.5586L11.8322 7.70045C12.0559 7.83741 12.0559 8.1626 11.8322 8.29932Z" })));
};

export { PlayCircleIcon };
//# sourceMappingURL=PlayCircleIcon.esm.js.map
